<script lang="ts">
import { defineComponent } from 'vue'
import OrderTable from '../components/OrderTable.vue'

export default defineComponent({
  name: 'order-list',
  components: { OrderTable },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
          <h1 class="text-2xl font-semibold text-gray-900 mb-2 sm:mb-0">Zoznam objednávok</h1>
        </div>
      </div>
      <order-table />
    </div>
  </main>
</template>
